<template>
  <div>
    <div class="demoboxAdd">
      <el-upload
        class="upload-demo"
        action="/service-center/upload/file/single"
        :headers="headers"
        :on-success="handleSuccess"
        :on-remove="handleRemove"
        :before-remove="beforeRemove"
        :before-upload="beforeModelUpload"
        :limit="1"
        accept=".stl,.obj,.STL,.OBJ,"
        :file-list="fileList"
      >
        <el-button type="primary">模型上传</el-button>
        <div slot="tip" class="el-upload__tip desinerInWorksnamec">
          支持STL、OBJ格式，建议上传STL，预览效果更佳。
        </div>
      </el-upload>
    </div>
  </div>
</template>

<script>
export default {
  name: "uploadDesignerImg",
  data() {
    return {
      headers: {
        Authorization: "Bearer " + this.$cookies.get("api_access_token"), //	可以是授权凭证用的参数值
      },
      fileList: [],
    };
  },
  methods: {
    handleSuccess(obj) {
      this.fileList.push(obj);
      this.$emit('modelList',this.fileList)
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.$emit('modelList',this.fileList)
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`).then(() => {
        this.fileList = [];
      });
    },
    beforeModelUpload(file) {
      let isLt2M = file.size / 1024 / 1024 < 100;
      if (!isLt2M) {
        this.$message.error("上传模型大小不能超过 100MB!");
        this.fileList = [];
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .upload-demo {
  width: 237px;
}
</style>



// WEBPACK FOOTER //
// src/components/uploadDesignerModel/uploadDesignerModel.vue